const schema = () => ({
  type: "object",
  required: ["lastname", "firstname", "cellphone"],
  properties: {
    firstname: {
      type: "string",
      title: "نام کاربر",
    },
    lastname: {
      type: "string",
      title: "نام خانوادگی",
    },
    cellphone: {
      type: "string",
      title: "شماره همراه",
      minLength: 9,
    },
    national_code: {
      type: "string",
      title: "کد ملی",
      minLength: 10,
      maxLength: 10,
    },
    birth_date: {
      type: "string",
      title: "تاریخ تولد",
    },
    gender: {
      type: "number",
      title: "جنسیت",
      oneOf: [
        { const: 1, title: "مرد" },
        { const: 0, title: "زن" },
      ],
    },
    user_category_id: {
      type: "string",
      title: "گروه",
    },
  },
});

export default schema;
